import { useCallback, useState } from "react";

export type UiSortOrder = "asc" | "desc";
export type ApiSortOrder = "ASC" | "DESC";

export function useTableSort<T extends string>(
  defaultField: T,
  defaultOrder: UiSortOrder = "asc"
) {
  const [sortBy, setSortBy] = useState<T>(defaultField);
  const [sortOrder, setSortOrder] = useState<UiSortOrder>(defaultOrder);

  const handleSort = useCallback(
    (field: T, onPageReset?: () => void) => {
      if (sortBy === field) {
        setSortOrder((o) => (o === "asc" ? "desc" : "asc"));
      } else {
        setSortBy(field);
        setSortOrder("asc");
      }
      onPageReset?.();
    },
    [sortBy]
  );

  return {
    sortBy,
    sortOrder,
    handleSort,
    sortParams: {
      sortBy,
      sortOrder: sortOrder.toUpperCase() as ApiSortOrder,
    },
  };
}
